import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-add-edit-domestic-tax-config',
  templateUrl: './add-edit-domestic-tax-config.component.html',
  styleUrls: ['./add-edit-domestic-tax-config.component.scss']
})
export class AddEditDomesticTaxConfigComponent implements OnInit,OnDestroy {
  taxData:any = {}
  apisub: Subscription
  constructor(@Inject(MAT_DIALOG_DATA) public parentdata: any, private loaderservice: LoaderServiceService, private apiservice: ApiService, private activemodal: MatDialogRef<AddEditDomesticTaxConfigComponent>) {

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_ENTITY_PRIMARY_TAX_DATA){
        if(resdata.result){
          // this.loaderservice.showLoader = false
          // this.activemodal.close({msg: 'success'})
          this.parentdata.ref.closeAll()
        }
      }
    })

   }

  ngOnInit(): void {
    
    this.taxData.pan_number = this.parentdata.taxData.pan_number
    this.taxData.tan_number = this.parentdata.taxData.tan_number
    this.taxData.gst_number = this.parentdata.taxData.gst_number
  }

  onPost(){
    let obj = {
      "pan_number": this.taxData.pan_number ? this.taxData.pan_number : null,
      "tan_number": this.taxData.tan_number ? this.taxData.tan_number : null,
      "gst_number": this.taxData.gst_number ? this.taxData.gst_number : null,
      "entity_hash": this.parentdata.entityHash,
      "tax_collection_status": this.parentdata.taxData?.entity_tax_collection_status  ? this.parentdata.taxData?.entity_tax_collection_status : 0,
      "bill_invoice_type": this.parentdata.taxData?.bill_invoice_type ?? 1,
    }

    Object.keys(obj).forEach(key => {
      if ((obj as any)[key] === null) {
        delete (obj as any)[key];
      }
    });

    console.log(obj);

    this.loaderservice.showLoader = true
    this.apiservice.addEditEntityPrimaryTaxData(obj)
    
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }

}
